<template>
  <b-table :busy="isBusy"
           small
           :fields="fields"
           :items="dataComputed"
           outlined
           thead-class="head-crud"
           tbody-tr-class="thead-row-class"
           show-empty
           @row-clicked="showModalInfo">
    <template v-slot:empty="scope">
      <div class="text-center">
        Sem registros
      </div>
    </template>

    <template slot="id"
              slot-scope="data">
      <b-form-checkbox v-model="data.item.ativo"
                       switch
                       :disabled="data.item.registro_oficial == 1 || (data.item.hasOwnProperty('vingenciaAtual') && data.item.registro_oficial === 0 ? !(data.item.vingenciaAtual) : false)"
                       value="1"
                       @change="updateAtivo(data.item)"
                       @keyup.native.enter="checkBoxTable(data.item)" />
    </template>

    <template slot="acoes"
              slot-scope="data">
      <div class="row align-middle">
        <button class="btn btn-default-table btn-sm mr-2"
                @click="showModal(data.item, false)">
          <svg class="icon--xxs "
               role="presentation">
            <use v-if="data.item.registro_oficial === 1 || !data.item.vingenciaAtual"
                 :xlink:href="'#' + eyeIcon.id" />
            <use v-else
                 :xlink:href="'#' + editIcon.id" />
          </svg>
        </button>
      </div>

      <!--<b-button class="ml-2" size="sm" variant="danger" @click="deleteFuneraria(data.item)" title="Ativar/Desativar funerária">
        <svg class="button_delete_label_icon icon&#45;&#45;xxs" role="presentation">
          <use :xlink:href="'#' + excludeIcon.id" />
        </svg>
      </b-button>-->
    </template>
    <template slot="acoes2"
              slot-scope="data">
      <div class="d-block text-right">
        <button class="btn btn-default-table btn-sm mr-2"
                title="Editar"
                @click="showModal(data.item, false)">
          <svg class="icon--xxs "
               role="presentation">
            <use v-if="data.item.registro_oficial == 1"
                 :xlink:href="'#' + eyeIcon.id" />
            <use v-else
                 :xlink:href="'#' + editIcon.id" />
          </svg>
        </button>
        <button class="btn btn-sm btn-danger"
                title="Excluir"
                type="button"
                @click="deleteItem(data.item)">
          <svg class="icon icon--xxs icon--clearFill"
               role="presentation">
            <use :xlink:href="'#' + trash.id" />
          </svg>
        </button>
      </div>
    </template>

    <template v-slot:table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle" />
        <strong> Carregando...</strong>
      </div>
    </template>
  </b-table>
</template>

<script>
  import editIcon from "@/assets/icons/pencil.svg?sprite"
  import eyeIcon from "@/assets/icons/eye.svg?sprite"
  import trash from '@/assets/icons/delete.svg?sprite'

  export default {
    name: "Table",
    props: ["isBusy", "fields", "data", "search", "fieldSearch"],
    data () {
      return {
        editIcon,
        eyeIcon,
        trash
      }
    },
    computed: {
      dataComputed: function () {
        let dataCopy = [...this.data]
        //let list = this.filter(dataCopy, this.search);
        return dataCopy
      },
      ibBusyComputed: function () {
        return this.isBusyComp
      }
    },
    /*watch:{
      search: function (newSearch, oldSearch) {
        this.viewWatch();
      }
    },
    created(){
      this.viewWatch = debounce(function(newVal){
      }, 100);
    },*/
    methods: {
      filter (data, search) {
        /*let newList = [];
        if(search){
          data.map(item => {
            if(item[this.fieldSearch].toLowerCase().match(search.toLowerCase()) != null){
              newList.push(item);
            }
          });
        }else{
          return data;
        }*/

        return data
      },
      checkBoxTable (data) {
        data.ativo = !data.ativo
        this.updateAtivo(data)
      },
      showModal (data, read) {
        this.$emit("showModal", {data,read})
      },
      showModalInfo (data, key) {
        this.$emit("showModal", {data,read: true})
      },
      updateAtivo (data) {
        this.$emit("onUpdateAtivo", data)
      },
      deleteItem (data) {
        this.$emit("deleteItem", data)
      },
      searchData () {
      },
    }
  }
</script>

<style lang="scss">
  @import "../../scss/_utilities/_exports";

  .head-crud {
    background: #01BFA5;
    vertical-align: middle;
    font-weight: 400px;
    font-size: pxToRem(14);
  }
  .thead-row-class td{
    vertical-align: center;
    padding-top: 10px;
    font-size: pxToRem(13);
    max-width: 250px;
  }

  .btn-default-table{
    background-color: #6c757d;
    color: white;
    fill: white;
  }
</style>
